import { ROUTE_NAMES as tradeInRoutes } from '../buyback/constants'
import { CHECKOUT as checkoutRoutes } from '../checkout/routes-names'
import { CMS as cmsRoutes } from '../cms/routes-names'
import { CUSTOMER_CARE as customerCareRoutes } from '../customer-care/route-names'
import { ROUTE_NAMES as userAccountRoutes } from '../dashboard/constants'
import { HOME } from '../home/route-names'
import { LEGAL_PAGE_NAME as legalRoutes } from '../legal/constants'
import { PRODUCT as productRoutes } from '../product-core/route-names'
import { ROUTES as productListingRoutes } from '../product-list/route-names'
import { ROUTES as reviewsRoutes } from '../reviews/route-names'

export const POPUP_TYPE = {
  APP_DOWNLOAD: 'appDownload',
  EMAIL_COLLECTOR: 'emailCollector',
} as const

export const TIME_BEFORE_POPUP = 10_000

export const EXCLUDED_ROUTES = {
  CHECKOUT: checkoutRoutes,
  TRADE_IN: tradeInRoutes,
  LEGAL: legalRoutes,
  USER_ACCOUNT: userAccountRoutes,
  CUSTOMER_CARE: customerCareRoutes,
  REVIEWS: reviewsRoutes,
  PRODUCT: productRoutes,
}

export const INCLUDED_ROUTES = {
  [POPUP_TYPE.APP_DOWNLOAD]: {
    HOME,
    PLP: productListingRoutes,
    ARTICLE: cmsRoutes.ARTICLE,
    ARTICLE_HUB: cmsRoutes.ARTICLE_HUB,
    ARTICLE_ROOT_HUB: cmsRoutes.ARTICLE_ROOT_HUB,
    BACK_STORIES: cmsRoutes.BACK_STORIES,
    BACK_STORIES_CATEGORY: cmsRoutes.BACK_STORIES_CATEGORY,
    EVENT: cmsRoutes.EVENT,
    BUYBACK_HOME: cmsRoutes.BUYBACK,
  },
  [POPUP_TYPE.EMAIL_COLLECTOR]: {
    HOME,
    PLP: productListingRoutes,
    ARTICLE: cmsRoutes.ARTICLE,
    ARTICLE_HUB: cmsRoutes.ARTICLE_HUB,
    ARTICLE_ROOT_HUB: cmsRoutes.ARTICLE_ROOT_HUB,
    BACK_STORIES: cmsRoutes.BACK_STORIES,
    BACK_STORIES_CATEGORY: cmsRoutes.BACK_STORIES_CATEGORY,
    EVENT: cmsRoutes.EVENT,
  },
}
